/* Impide pagar una personalizacion sin docena de pelotas, y resuelve el problema
   en un clic. Se apoya en product_type de /cart.js. */
(function () {
  var nativeFetch = window.fetch.bind(window);
  var SUGGEST_ID = 44095688835237; /* Fly Soft - 12 unidades */
  var SUGGEST_LABEL = 'Agregar Fly Soft — $650';
  var busy = false;

  function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function norm(value) {
    return (value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();
  }

  function evaluate(cart) {
    var hasPerso = false;
    var hasBalls = false;
    (cart.items || []).forEach(function (it) {
      var t = norm(it.product_type);
      if (t === 'personalizacion') hasPerso = true;
      if (t === 'pelotas') hasBalls = true;
    });
    return hasPerso && !hasBalls;
  }

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function sectionIds() {
    var cd = drawerEl();
    if (cd && typeof cd.getSectionsToRender === 'function') {
      try { return cd.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return null;
  }

  function addSuggested(btn) {
    if (busy) return;
    busy = true;
    var original = btn.textContent;
    btn.textContent = 'Agregando...';
    btn.disabled = true;

    var payload = { items: [{ id: SUGGEST_ID, quantity: 1 }] };
    var ids = sectionIds();
    if (ids) { payload.sections = ids.join(','); payload.sections_url = window.location.pathname; }

    nativeFetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        busy = false;
        btn.disabled = false;
        btn.textContent = original;
        var cd = drawerEl();
        if (cd && json && json.sections && typeof cd.renderContents === 'function') {
          try { cd.renderContents(json); } catch (e) {}
          document.dispatchEvent(new CustomEvent('mb:cart:changed'));
          setTimeout(check, 200);
          return;
        }
        window.location.reload();
      })
      .catch(function () { busy = false; btn.disabled = false; btn.textContent = original; window.location.reload(); });
  }

  function box(ctas) {
    var parent = ctas.parentNode;
    if (!parent) return null;
    var el = parent.querySelector(':scope > .mb-guard');
    if (!el) {
      el = document.createElement('div');
      el.className = 'mb-guard';
      el.innerHTML =
        '<strong>Te falta la docena</strong>' +
        '<p class="mb-guard-text">La personalización se imprime sobre nuestras pelotas, ' +
        'así que tu pedido necesita al menos una docena.</p>' +
        '<div class="mb-guard-actions">' +
        '<button type="button" class="mb-guard-btn" data-mb-guard-add>' + SUGGEST_LABEL + '</button>' +
        '<a class="mb-guard-link" href="' + routeRoot() + 'collections/frontpage">Ver todas las pelotas</a>' +
        '</div>';
      parent.insertBefore(el, ctas);
      el.querySelector('[data-mb-guard-add]').addEventListener('click', function () {
        addSuggested(this);
      });
    }
    return el;
  }

  function render(block) {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var el = box(ctas);
      if (el) el.hidden = !block;
    });

    document.querySelectorAll('#CartDrawer-Checkout, #checkout, button[name="checkout"]').forEach(function (btn) {
      if (block) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('data-mb-blocked', '1');
      } else if (btn.getAttribute('data-mb-blocked') === '1') {
        btn.removeAttribute('disabled');
        btn.removeAttribute('data-mb-blocked');
      }
    });

    document.querySelectorAll('.cart__dynamic-checkout-buttons, #dynamic-checkout-cart').forEach(function (el) {
      el.style.display = block ? 'none' : '';
    });
  }

  function check() {
    if (!document.querySelector('.cart__ctas')) return;
    nativeFetch(routeRoot() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(evaluate(cart)); })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', check);
  document.addEventListener('shopify:section:load', check);
  document.addEventListener('mb:cart:changed', function () { setTimeout(check, 250); });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-drawer, .cart-drawer, #cart-icon-bubble, cart-remove-button, .quantity__button')) {
      setTimeout(check, 450);
    }
  });

  var patched = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    var isCart = href.indexOf('/cart/') !== -1;
    return patched.apply(this, arguments).then(function (res) {
      if (isCart) setTimeout(check, 350);
      return res;
    });
  };

  if (document.readyState !== 'loading') check();
})();
